import { z } from 'zod';

import { storedObjectSchema } from '../../../utils';
import { columnBaseSchema } from '../base';

/**
 * The single column of a zero block. Its widgets are placed absolutely, so the
 * column is a positioning context and nothing more — `.zero-column-styles()` is
 * two rules and reads no variable at all. No settings, hence no props.
 */
export const columnZeroDataSchema = z.object({});

export const columnZeroSchema = columnBaseSchema.extend({
    entitySubType: z.literal('zero'),
    props: storedObjectSchema(columnZeroDataSchema),
    version: z.literal(0),
});

export const columnZeroV0Schema = columnZeroSchema;
export type ColumnZeroV0 = z.infer<typeof columnZeroV0Schema>;
